// Shared helpers for pages
export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="page-header" data-testid={testid}>
      <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", gap: 24, flexWrap: "wrap" }}>
        <div>
          <div className="overline" style={{ marginBottom: 6 }}>Módulo</div>
          <h1 className="font-display font-black" style={{ fontSize: "2rem", lineHeight: 1 }}>{title}</h1>
          {subtitle && <p style={{ color: "#52525B", marginTop: 8, fontSize: "0.9rem" }}>{subtitle}</p>}
        </div>
        {actions && <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>{actions}</div>}
      </div>
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    "Pendente": "badge-pendente",
    "Em Execução": "badge-execucao",
    "Paralisada": "badge-paralisada",
    "Concluída": "badge-concluida",
    "Cancelada": "badge-cancelada",
    "Aberta": "badge-aberta",
    "Em tratamento": "badge-tratamento",
    "Encerrada": "badge-encerrada",
    "Concluído": "badge-concluida",
    "Em Andamento": "badge-execucao",
  };
  return <span className={`badge ${map[status] || "badge-pendente"}`}>{status}</span>;
}

export function EmptyState({ title, description, action }) {
  return (
    <div className="empty">
      <div className="font-display font-black text-lg mb-2">{title}</div>
      {description && <div className="text-sm mb-4">{description}</div>}
      {action}
    </div>
  );
}

export function Progress({ value }) {
  const v = Math.min(100, Math.max(0, value || 0));
  return (
    <div>
      <div className="progress-track">
        <div className="progress-fill" style={{ width: `${v}%` }} />
      </div>
      <div className="font-mono text-xs mt-1" style={{ color: "#52525B" }}>{v.toFixed(1)}%</div>
    </div>
  );
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("pt-BR");
  } catch {
    return iso;
  }
}

// Controle de acesso a valores financeiros: supervisor/operador não veem R$ (o backend também não envia).
let _verValores = true;
export const setVerValores = (v) => { _verValores = !!v; };
export const verValores = () => _verValores;
export const ROLES_SEM_FINANCEIRO = ["supervisor", "operador"];
// Nome curto (apelido) do item para leitura rápida no campo; cai na descrição completa quando não há.
export const nomeItem = (i) => (i?.apelido && i.apelido.trim()) || i?.descricao || "";
const _KW_CAT = { horizontal: /horizontal|pintura|termopl[aá]stic|demarca|faixa|tinta|aspers|extrus|hot\s*spray|zebrad|legenda|microesfera|setas?\b/i, vertical: /vertical|placa|suporte|poste|p[óo]rtico|bandeira|pel[ií]cula|chapa/i };
// Item pertence à categoria? Aceita a categoria gravada ou, se vier vazia/"Outros", a descrição do serviço.
export const itemDaCategoria = (item, cat) => {
  const c = (item?.categoria || "").toLowerCase();
  if (c === cat) return true;
  return (!c || c === "outros") && !!_KW_CAT[cat]?.test(item?.descricao || "");
};

export function formatCurrency(v) {
  if (!_verValores) return "—";
  return (v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function Modal({ open, onClose, title, children, size = "md" }) {
  if (!open) return null;
  const width = size === "lg" ? 720 : size === "xl" ? 960 : 520;
  return (
    <div
      style={{
        position: "fixed", inset: 0, background: "rgba(10,10,10,0.6)", zIndex: 100,
        display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "48px 16px", overflowY: "auto",
      }}
      onClick={onClose}
      data-testid="modal-overlay"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ background: "#FFF", width: "100%", maxWidth: width, borderRadius: 4, border: "1px solid #E4E4E7" }}
      >
        <div style={{ padding: "20px 24px", borderBottom: "1px solid #E4E4E7", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h3 className="font-display font-bold" style={{ fontSize: "1.25rem" }}>{title}</h3>
          <button className="btn btn-ghost btn-sm" onClick={onClose} data-testid="modal-close">Fechar</button>
        </div>
        <div style={{ padding: 24 }}>{children}</div>
      </div>
    </div>
  );
}
